import React from 'react';
import IntroComponent, { AnimatedTitle } from '@framework/ui/Pages/Landing/Sections/Intro';
import StartActions from '../StartActions';

import video from './assets/video.mp4';
import poster from './assets/poster.webp';
import styles from './intro.module.scss';

const Intro = () => (
  <IntroComponent
    className={ styles.intro }
    title={ (
      <>
        IPO research distribution made { ' ' }
        <AnimatedTitle
          sliderList={ ['accessible.', 'simple.', 'efficient.', 'compliant.', 'secure.'] }
          className={ styles.introAnimatedTitle }
        />
      </>
    ) }
    description={ (
      <p className={ styles.description }>
        ResearchRoom is a secure document e-delivery service dedicated to IPO research. It simplifies
        compliance without compromising your process and provides a seamless investor experience,
        backed by fanatical 24x7 support for all stakeholders.
      </p>
    ) }
    video={ video }
    poster={ poster.src }
    actionButtons={ <StartActions /> }
  />
);

export default Intro;
